import React from 'react';
import { firmInfo, values } from '../mock';
import * as LucideIcons from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <span className="caption mb-4 block">
            About Us
          </span>
          <h2 className="heading-2 mb-6">
            Who We Are
          </h2>
        </div>

        {/* About Content */}
        <div className="grid lg:grid-cols-2 gap-12 mb-20">
          <div>
            <p className="body-large mb-6 leading-relaxed">
              {firmInfo.about}
            </p>
            <p className="body-medium leading-relaxed">
              Our firm continues to grow through maintaining the highest standards of professional excellence, 
              adapting to the latest developments in the profession, and building long-term relationships 
              with our clients based on trust and mutual respect.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-lg border border-[hsl(var(--border-light))]">
            <h3 className="heading-5 mb-6">Quick Facts</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[hsl(var(--primary-blue))] rounded-full mt-2" />
                <div>
                  <p className="body-small font-semibold text-[hsl(var(--text-primary))]">Established</p>
                  <p className="body-small text-[hsl(var(--text-secondary))]">{firmInfo.established}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[hsl(var(--primary-blue))] rounded-full mt-1 shrink-0" />
                <div>
                  <p className="body-small font-semibold text-[hsl(var(--text-primary))]">Location</p>
                  <p className="body-small text-[hsl(var(--text-secondary))]">{firmInfo.location}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-2 h-2 bg-[hsl(var(--primary-blue))] rounded-full mt-2" />
                <div>
                  <p className="body-small font-semibold text-[hsl(var(--text-primary))]">Specialization</p>
                  <p className="body-small text-[hsl(var(--text-secondary))]">Audit, Taxation, Advisory & Accounting</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Core Values */}
        <div>
          <h3 className="heading-4 mb-10 text-center">Our Core Values</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => {
              const Icon = LucideIcons[value.icon];
              return (
                <div
                  key={index}
                  className="bg-white p-6 rounded-lg border border-[hsl(var(--border-light))] hover:border-[hsl(var(--primary-blue))] hover:shadow-lg hover:shadow-[hsl(var(--primary-blue))/.2] transition-all duration-300 text-center"
                >
                  <div className="w-12 h-12 bg-[hsl(var(--primary-blue)/.1)] rounded-lg flex items-center justify-center mb-4 mx-auto">
                    {Icon && <Icon className="text-[hsl(var(--primary-blue))]" size={24} />}
                  </div>
                  <h4 className="heading-6">{value.title}</h4>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
